import styled from 'styled-components'

import EquationCross from 'components/core/icons/factory/EquationCross'
import EquationEquals from 'components/core/icons/factory/EquationEquals'
import EquationRoot from 'components/core/icons/factory/EquationRoot'
import EquationRootTail from 'components/core/icons/factory/EquationRootTail'
import { device } from 'components/draw/constants'

const GooRightContainer = styled.div`
  z-index: 7;
  color: black;
  font-family: 'Matter';
  font-weight: 700;

  display: flex;
  flex-direction: column;

  box-shadow: 0px -3px 8px rgba(255, 255, 255, 0.2), 0px 24px 40px rgba(0, 0, 0, 0.08),
    0px 12px 20px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(0, 0, 0, 0.04);
  border-radius: 32px;

  @media ${device.laptopMax} {
    align-self: center;
    width: calc(100% - 40px);
  }
`

const GooRightHeader = styled.div`
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(24px);

  padding: 16px;

  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  font-size: 18px;
`

const GooRightDetails = styled.div`
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;

  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  font-size: 24px;

  @media ${device.laptopMax} {
    flex-direction: column;
    gap: 24px;
  }
`

const GooEquationContainer = styled.div`
  display: flex;
  position: relative;
`

const EquationRootContainer = styled.div`
  position: absolute;
  pointer-events: none;
  left: 0;
  width: 100%;
  overflow: hidden;

  @media (max-width: 1033px) {
    left: -20px;
  }
`

const EquationRootTailConatiner = styled.div`
  position: absolute;
  pointer-events: none;
  right: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

const EquationLeft = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 36px;
  margin-top: 10px;

  /* KLUDGE(johnrjj) */
  min-width: 68px;

  @media ${device.laptopMax} {
    margin-left: 28px;
  }
`

const EquationRight = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-top: 10px;
  font-variant-numeric: tabular-nums;
`

const EquationDetail = styled.div`
  font-weight: 400;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.4);
  font-variant-numeric: tabular-nums;
`

const EquationCrossContainer = styled.div`
  margin: 12px 20px 0 20px;

  @media ${device.laptopMax} {
    margin-left: 10px;
    margin-right: 10px;
  }
`

const EquationEqualsContainer = styled.div`
  margin-left: 16px;

  @media ${device.laptopMax} {
    margin-left: 0;
  }
`

const EquationTotal = styled.div`
  font-size: 28px;
  background-color: #8ef42e;
  padding: 12px 24px;
  border-radius: 12px;
  text-align: center;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`

const GooBottomRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    gap: 2.5px;
  `};
`

export function getCleanNumber(num: number, minimumFractionDigits = 2, maximumFractionDigits = 2) {
  const options = { minimumFractionDigits, maximumFractionDigits }

  if (num > 1000000000) {
    return `${(num / 1000000000).toLocaleString(undefined, options)}B`
  } else if (num > 1000000) {
    return `${(num / 1000000).toLocaleString(undefined, options)}M`
  }
  return num.toLocaleString(undefined, options)
}
function GooEquation({ gooStaked, multiplier }: { gooStaked: number; multiplier: number }) {
  const isGooGreatedThan100 = gooStaked > 100

  const gooDecimal = isGooGreatedThan100 ? 2 : 4
  const gooStakedClean = getCleanNumber(gooStaked, gooDecimal, gooDecimal)
  const multiplierClean = getCleanNumber(multiplier, 0)

  const totalGoo = Math.sqrt(gooStaked * multiplier)
  const isTotalGooPerDayGreaterThan50 = totalGoo > 50
  const totalGooDecimal = isTotalGooPerDayGreaterThan50 ? 4 : 4
  const totalGooClean = getCleanNumber(totalGoo, totalGooDecimal, totalGooDecimal)

  return (
    <GooRightContainer style={{ width: 'fit-content' }}>
      <GooRightHeader>Goo Production Rate</GooRightHeader>
      <GooRightDetails>
        <GooEquationContainer>
          <EquationLeft>
            <div>{gooStakedClean}</div>
            <EquationDetail>Goo in tank</EquationDetail>
          </EquationLeft>
          <EquationCrossContainer>
            <EquationCross />
          </EquationCrossContainer>
          <EquationRight>
            <div>{multiplierClean}x</div>
            <EquationDetail>Multiplier</EquationDetail>
          </EquationRight>
          <EquationRootContainer>
            <EquationRoot />
          </EquationRootContainer>
          <EquationRootTailConatiner>
            <EquationRootTail />
          </EquationRootTailConatiner>
        </GooEquationContainer>
        <GooBottomRightContainer>
          <EquationEqualsContainer>
            <EquationEquals />
          </EquationEqualsContainer>
          <EquationTotal>{totalGooClean} Goo/d</EquationTotal>
        </GooBottomRightContainer>
      </GooRightDetails>
    </GooRightContainer>
  )
}

export default GooEquation
